import { useImmer } from "use-immer";
import { useContext, useEffect, useRef, useState } from "react";
import SimpleReactValidator from "simple-react-validator";
import { useCreateOrEditQueries } from "./useCreateOrEditQueries";
import { useCategoryQueries } from "../../MasterData/hooks";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { AppContext } from "../../../store/AppScopeProvider";
import { useRecipeDetails } from "./useRecipeDetails";
import { errorMessage } from "../../../utils";
import moment from "moment";

export const useCreateOrEdit = ({
  list = true,
  detailsId = null,
  categorylist = true,
  ingredientslist = true,
  altunitlist = true,
  recipeId,
}) => {
  const quillRef = useRef(null);

  const { basicDetailsQuery } = useRecipeDetails({ recipeId });
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const search = searchParams.get("tab");
  const typeParams = searchParams.get("type");
  const isIngredientsApiEnabled =
    search === "ingredients" || location.pathname.includes("details");
  const createId = location.state?.createId;
  const { globalData } = useContext(AppContext);
  const [force, forceUpdate] = useState();
  const validator = useRef(
    new SimpleReactValidator({
      autoForceUpdate: { forceUpdate: forceUpdate },
    }),
  );
  const unitValidator = useRef(
    new SimpleReactValidator({
      validators: {
        customNumeric: {
          message:
            "The value must be a number greater than 0, and cannot be exactly 0.",
          rule: (val) => {
            return parseFloat(val) > 0;
          },
          required: true,
        },
      },
    }),
  );
  const howToPrepareValidator = useRef(
    new SimpleReactValidator({
      autoForceUpdate: { forceUpdate: forceUpdate },
    }),
  );
  const ingredientsValidator = useRef(
    new SimpleReactValidator({
      validators: {
        notZeroDecimal: {
          message: "This value must be greater than zero.",
          rule: (val) => {
            return parseFloat(val) > 0;
          },
          required: true,
        },
      },
    }),
  );
  //////////////////////////////////Ingredients///////////////////////////////////////////////////

  const [ingredients, setIngredients] = useImmer({
    isErrorMessage: false,
    errorMessage: [],
    errorData: [],
    isOpenSyncModal: false,
    data: {
      recipe_id: "",
      is_alternate_UOM: 0,
      total_weight: "",
      total_ingredient_weight: "",
      selling_unit_id: "",
      sync_type: "",
      scheduled_date: "",
      alt_units: [
        {
          base_unit_qty: "",
          base_unit_id: "",
          alt_unit_qty: "",
          alt_unit_id: "",
        },
      ],
      groups: [
        {
          name: "Group 1",
          position: 1,
          total_qty: 0,
          total_qty_unit: "",
          has_boiling_weight: 0,
          total_ingredient_qty: 0,
          ingredients: [
            {
              rowID: 1,
              groupIndex: 0,
              type: "",
              ingredient_id: "",
              base_unit_id: "",
              base_unit_qty: "",
              is_main_ingredient: 1,
              units: [],
            },
          ],
        },
      ],
    },
    isCreateOpen: false,
    dialogMessagetype: "created",
    isChanged: false,
  });

  useEffect(() => {
    const kgId = globalData?.defaultUnits.find((i) => i.label === "kg").value;
    if (kgId) {
      setIngredients((draft) => {
        draft.data.alt_units[0].base_unit_id = kgId;
      });
    }
  }, [globalData]);
  const handleSuccessModal = () => {
    navigate(`/recipe/details/${recipeId}/?basic-details`, { replace: true });
  };

  useEffect(() => {
    if (location?.search.includes("status")) {
      setIngredients((draft) => {
        draft.isCreateOpen = true;
        draft.dialogMessagetype = "created";
      });
    } else if (location?.search.includes("cloneStatus")) {
      setIngredients((draft) => {
        draft.isCreateOpen = true;
        draft.dialogMessagetype = "cloned";
      });
    } else {
      setIngredients((draft) => {
        draft.isCreateOpen = false;
      });
    }
  }, [location?.search]);

  useEffect(() => {
    if (basicDetailsQuery?.data?.status === 1) {
      setIngredients((draft) => {
        draft.isCreateOpen = false;
      });
    }
  }, [basicDetailsQuery?.data?.status]);

  ////////////////////////////////////////////////////Basic Details/////////////////////////////////////////
  const [basicdetails, setBasicDetails] = useImmer({
    data: {
      name: "",
      category_id: "",
      subcategory_id: "",
      type: "",
      is_batch_group: 0,
      bowl_capacity: "",
      image: null,
      uncompressed_image: null,
      status: 0,
      subcategories: [],
      plu: "",
      tax_group_id: "",
      show_in_chart: 1,
    },

    media: "",
    type: "thumbnail_image",
  });

  ///////////////////////////////////Chart Settings//////////////////////////////////////////////////
  const [chartSettings, setChartSettings] = useImmer({
    data: {
      recipe_id: "",
      bread_moulder_enabled: 0,
      front_roller_setting_no: "",
      bread_moulder_setting_chart: "",
      proving_time_enabled: 0,
      proving_time: "",
      oven_time_temp_enabled: 0,
      baking_time: "",
      temperature: "",
      steaming_shots: "",
      cut: "",
      decorate: "",
      oven_temperature_top: "",
      oven_temperature_bottom: "",
      production_wastage_enabled: 0,
      time_period: "",
      primary: 0,
      mandatory: 0,
      roll_moulder_enabled: 0,
      roll_moulder_setting_no: "",
      roll_moulder_rounding_time: "",
      pastry_sheeter_enabled: 0,
      pastry_sheeter_setting_no: "",
      pastry_sheeter_amount_of_turns: "",
      time_through_pastry_sheeter_final_settings: "",
      pastry_sheeter_bottom_weight: "",
      pastry_sheeter_top_weight: "",
      pastry_sheeter_filling_weight: "",
      pastry_sheeter_unbacked_weight: "",
      before_baking: "",
      after_baking: "",

      induction_cooker_status: 0,
      initial_watts: "",
      initial_time: "",
      initial_description: "",
      increased_watts: "",
      increased_time: "",
      increased_description: "",
    },
  });

  ////////////////////////////////////////How to Prepare//////////////////////////////////////////////
  const [state, setState] = useImmer({
    data: {
      steps: [
        {
          step: "",
          image_url: "",
          imageFile: "",
          loading: false,
        },
      ],
      videos: [],
      method: "",
    },
    type: "",
    media: "",
    videoUrl: "",
    index: null,
  });
  const [value, setValue] = useState(0);

  const handleChange = (value, createId = null) => {
    navigate(value, { replace: true, state: { createId } });
  };

  const handleTabCLick = (event, newValue) => {
    const value = newValue ? `?tab=${newValue}` : "";
    navigate(
      detailsId
        ? `/recipe/edit/${detailsId}${value}`
        : `/recipe/create${value}`,
      { replace: true },
    );
  };

  ///////BasicDetails Query////////

  const { listQuery: categoryListQuery } = useCategoryQueries({
    categorylist,
  });
  const {
    createBasicDetails,
    createIngredients,
    listQuery,
    altunitListQuery,
    createChartSettings,
    createRecipePreapration,
    createImageUrl,
    createImageVideoUrl,
    createVideoUrl,
    updateBasicDetails,
    basicDetailsData,
    updateChartSettings,
    chartSettingsDetails,
    updateIngredients,
    ingredientsDetails,
    updatePreparationSteps,
    preparationStepsDetails,
    pluListQuery,
    taxListQuery,
  } = useCreateOrEditQueries({
    list,
    detailsId,
    ingredientslist,
    altunitlist,
    isIngredientsApiEnabled,
    setIngredients,
    state,
    setState,
  });
  const categoryIds = categoryListQuery?.data
    ? categoryListQuery?.data?.map((i) => ({
        label: i?.name,
        value: i?.id,
      }))
    : [];

  const pluOptions =
    pluListQuery?.data?.data &&
    Object.values(pluListQuery?.data?.data).map((item) => ({
      label: item.plu,
      value: item.plu,
      product: item.name,
    }));

  const optionsTaxGroup = taxListQuery?.data?.map((item) => ({
    label: item.name,
    value: item.id,
  }));
  const typeData = globalData?.Recipe_types;

  const ingredientsList = listQuery?.data?.ingredients
    ? listQuery?.data?.ingredients?.map((i, index) => ({
        label: i?.name,
        value: i?.id,
        type: "ingredient",
        is_batch_group: false,
        units: i?.units.map((item) => ({ ...item, ignoredUnit: false })),
      }))
    : [];

  const recipeList = listQuery?.data?.recipes
    ? listQuery?.data?.recipes?.map((i, index) => ({
        label: i?.name,
        value: i?.id,
        type: "recipe",
        is_batch_group: i?.is_batch_group,
        units: i?.units.map((item) => ({ ...item, ignoredUnit: false })),
      }))
    : [];

  const ignoredList = listQuery?.data?.ignoreUnits
    ? listQuery?.data?.ignoreUnits?.map((i, index) => ({
        alt_unit_symbol: i?.symbol,
        alt_unit_id: i?.id,
        ignoredUnit: true,
      }))
    : [];

  const combinedArray = [...ingredientsList, ...recipeList].map((item) => ({
    ...item,
    units: [...item.units, ...ignoredList],
  }));

  const alternativeunitList = altunitListQuery?.data || [];

  //////////BasicDetails Hooks/////////////////

  const TypeHandler = (event, option, name) => {
    const typeOptions = option ? option.value : "";
    setBasicDetails((draft) => {
      draft.data[name] = typeOptions;
    });
    if (name === "type") {
      if (option?.value != "finishedproduct") {
        setBasicDetails((draft) => {
          draft.data.plu = "";
        });
      }
    }
  };

  const basicDetailsOnChange = (e) => {
    const { name, value } = e.target;
    setBasicDetails((draft) => {
      draft.data[name] = value;
    });
  };

  const onHandleChange = (e) => {
    const value = e.target.checked === true ? 1 : 0;
    setBasicDetails((draft) => {
      draft.data.is_batch_group = value;
    });
  };

  const CategoryChangeHandler = (event, option) => {
    const categoryOption = option ? option.value : "";
    const selectedCategory = categoryListQuery?.data?.find(
      (category) => category.id === categoryOption,
    );

    const subcategoryForSelectedCategory = selectedCategory
      ? selectedCategory.subData
      : [];

    setBasicDetails((draft) => {
      draft.data.category_id = categoryOption;
      draft.data.subcategories = subcategoryForSelectedCategory;
    });
  };

  const SubcategoryChangeHandler = (event, option) => {
    const subCategoryOption = option ? option.id : "";
    setBasicDetails((draft) => {
      draft.data.subcategory_id = subCategoryOption;
    });
  };

  const basicDetailsHandleDropzone = (e) => {
    const imageFile = e[0];
    setBasicDetails((draft) => {
      draft.media = imageFile;
    });

    const { type } = basicdetails;
    let imagesFormdata = new FormData();
    imagesFormdata.append("type", type);
    imagesFormdata.append("media", imageFile);
    createImageUrl.mutate(imagesFormdata);
  };

  useEffect(() => {
    if (createImageUrl?.data) {
      setBasicDetails((draft) => {
        draft.data.image = createImageUrl.data.url;
        draft.data.uncompressed_image = createImageUrl.data.app_url;
      });
    }
  }, [createImageUrl.data]);

  const handleRemoveImage = () => {
    setBasicDetails((draft) => {
      draft.media = "";
      draft.data.image = "";
    });
  };

  useEffect(() => {
    if (basicDetailsData.status === "success") {
      setBasicDetails((draft) => {
        draft.data = basicDetailsData.data;
      });
    }
  }, [basicDetailsData.status]);

  const basicDetailsOnSubmit = () => {
    if (validator.current.allValid()) {
      let formData = new FormData();
      const {
        name,
        category_id,
        subcategory_id,
        type,
        is_batch_group,
        bowl_capacity,
        image,
        status,
        plu,
        tax_group_id,
        uncompressed_image,
        show_in_chart,
      } = basicdetails.data;

      formData.append("name", name);
      formData.append("category_id", category_id);
      formData.append("subcategory_id", subcategory_id);
      formData.append("type", type);
      formData.append("is_batch_group", is_batch_group);
      formData.append("bowl_capacity", is_batch_group ? bowl_capacity : 0);
      formData.append("status", status);
      formData.append("image", image);

      type === "finishedproduct" &&
        formData.append("show_in_chart", show_in_chart);

      uncompressed_image &&
        formData.append("uncompressed_image", uncompressed_image);
      formData.append("plu", plu === "null" || plu === null ? "" : plu);
      formData.append("tax_group_id", tax_group_id);

      detailsId
        ? updateBasicDetails.mutate({ detailsId, formData, handleChange })
        : createBasicDetails.mutate({
            formData,
            handleChange,
          });
    } else {
      validator.current.showMessages();
      forceUpdate(1);
    }
  };

  /////ingredients hooks/////////////////

  // add ingredients row
  const addIngredientsHandle = (groupIndex) => {
    const newRows = {
      rowID: ingredients.data.groups[groupIndex].ingredients.length + 1,
      groupIndex: groupIndex,
      ingredient_id: "",
      base_unit_qty: "",
      base_unit_id: "",
      is_main_ingredient: 0,
      has_boiling_weight: 0,
      total_ingredient_qty: 0,
    };
    setIngredients((draft) => {
      const currentGroup = draft.data.groups[groupIndex];
      currentGroup.ingredients.push(newRows);
    });
  };

  //add altUnits row
  const addUnitsHandle = () => {
    if (unitValidator.current.allValid()) {
      const newAltUnitRows = {
        base_unit_id: "",
        base_unit_qty: "",
        alt_unit_id: "",
        alt_unit_qty: "",
      };
      setIngredients((draft) => {
        const currentRow = draft.data.alt_units;
        currentRow.push(newAltUnitRows);
      });
    } else {
      unitValidator.current.showMessages();
      forceUpdate(1);
    }
  };

  const IngredientsChangehandler = (event, option, groupindex, rowindex) => {
    if (option) {
      const selectedIngredientId = option ? option.value : "";
      const unitsForSelectedIngredient = option.units;
      setIngredients((draft) => {
        draft.data.groups[groupindex].ingredients[rowindex].ingredient_id =
          selectedIngredientId;
        draft.data.groups[groupindex].ingredients[rowindex].units =
          unitsForSelectedIngredient;
        draft.data.groups[groupindex].ingredients[rowindex].type = option
          ? option.type
          : "";
        draft.isChanged = true;
      });
    } else {
      setIngredients((draft) => {
        draft.data.groups[groupindex].ingredients[rowindex].ingredient_id = "";
        draft.data.groups[groupindex].ingredients[rowindex].units = [];
        draft.data.groups[groupindex].ingredients[rowindex].type = "";
        draft.isChanged = true;
      });
    }
  };

  const unitsChangehandler = (event, option, index, ingredientIndex) => {
    const unitsOption = option ? option.alt_unit_id : "";
    setIngredients((draft) => {
      draft.data.groups[index].ingredients[ingredientIndex].base_unit_id =
        unitsOption;
      draft.isChanged = true;
    });
  };

  useEffect(() => {
    console.log(ingredients.isChanged);
  }, [ingredients.isChanged]);

  const sellingUnitChange = (e, option) => {
    const unitsOption = option ? option.id : "";
    setIngredients((draft) => {
      draft.data.selling_unit_id = unitsOption;
      draft.isChanged = true;
    });
  };

  const onIngredientsOrderChange = async (data, index) => {
    setIngredients((draft) => {
      draft.data.groups[index].ingredients = data;
      draft.isChanged = true;
    });
  };

  const altUnitChangeHandler = (name, option, index) => {
    let removedDataId = ingredients.data.alt_units[index][name];
    if (option) {
      const id = option ? option.id : "";
      setIngredients((draft) => {
        draft.data.alt_units[index][name] = id;
        if (removedDataId === draft.data.selling_unit_id) {
          draft.data.selling_unit_id = null;
        }
        draft.isChanged = true;
      });
    } else {
      setIngredients((draft) => {
        draft.data.alt_units[index][name] = "";

        if (removedDataId === draft.data.selling_unit_id) {
          draft.data.selling_unit_id = null;
        }
        draft.isChanged = true;
      });
    }
  };

  const handleDelete = (index) => {
    console.log(index, "ddddd");

    setIngredients((draft) => {
      if (index !== 0) {
        draft.data.alt_units = [
          ...draft.data.alt_units.filter((data, i) => i !== index),
        ];
        draft.isChanged = true;
      }
    });
  };

  const handleRemoveRows = (info) => {
    const itemIndex = info.row.index;
    const groupIndex = info?.row?.original?.groupIndex;
    const groupLength = ingredients.data.groups[groupIndex].ingredients.length;
    if (groupLength === 1) {
      const newGroups = ingredients.data.groups.filter((_, index) => {
        return index !== groupIndex;
      });
      const newindices = newGroups.map((grp, grpIndex) => {
        return {
          ...grp,
          ingredients: grp.ingredients.map((item) => ({
            ...item,
            groupIndex: grpIndex,
          })),
        };
      });
      setIngredients((draft) => {
        draft.data.groups = newindices;
        draft.isChanged = true;
      });
    } else {
      setIngredients((draft) => {
        draft.data.groups[groupIndex].ingredients?.splice(itemIndex, 1);
        draft.isChanged = true;
      });
    }
  };

  const addNewGroup = () => {
    setIngredients((draft) => {
      const newPosition = draft.data.groups.length + 1;
      draft.data.groups.push({
        name: `Group ${newPosition}`,
        position: newPosition,
        total_qty: 0,
        total_qty_unit: "",
        has_boiling_weight: 0,
        total_ingredient_qty: 0,
        ingredients: [
          {
            groupIndex: ingredients?.data?.groups?.length,
            ingredient_id: "",
            base_unit_id: "",
            base_unit_qty: "",
            is_main_ingredient: 0,
          },
        ],
      });
    });
  };

  const onRadioButtonChange = (rowId, groupIndex) => {
    const newData = ingredients.data.groups.map((grp, grpIndex) => {
      if (groupIndex === grpIndex) {
        return {
          ...grp,
          ingredients: grp.ingredients?.map((ingredient, index) => ({
            ...ingredient,
            is_main_ingredient:
              index === rowId ? (ingredient.is_main_ingredient ? 0 : 1) : 0,
          })),
        };
      } else {
        return {
          ...grp,
          ingredients: grp.ingredients?.map((ingredient, index) => ({
            ...ingredient,
            is_main_ingredient: 0,
          })),
        };
      }
    });
    setIngredients((draft) => {
      draft.data.groups = newData;
      draft.isChanged = true;
    });
  };

  // Move an ingredient from one group to another
  const moveIngredient = (
    sourceGroupIndex,
    targetGroupIndex,
    ingredientIndex,
  ) => {
    if (sourceGroupIndex === targetGroupIndex) return;

    setIngredients((draft) => {
      const sourceGroup = draft.data.groups[sourceGroupIndex];

      const targetGroup = draft.data.groups[targetGroupIndex];

      // Check if ingredient already exists in target group
      const ingredientId =
        sourceGroup.ingredients[ingredientIndex]?.ingredient_id;
      const ingredientExists = targetGroup.ingredients.some(
        (item) => item.ingredient_id === ingredientId,
      );

      if (ingredientExists) {
        errorMessage("This ingredient already exists in the target group.");
        return;
      }
      if (!sourceGroup) return;

      const [moved] = sourceGroup.ingredients.splice(ingredientIndex, 1);
      if (!moved) return;

      // set the new groupIndex and append to target group
      moved.groupIndex = targetGroupIndex;
      draft.data.groups[targetGroupIndex].ingredients.push(moved);

      // if source group becomes empty, remove that group
      if (draft.data.groups[sourceGroupIndex].ingredients.length === 0) {
        draft.data.groups.splice(sourceGroupIndex, 1);
      }

      // Reindex groupIndex for all ingredients to keep consistency
      draft.data.groups.forEach((grp, idx) => {
        grp.ingredients.forEach((item) => {
          item.groupIndex = idx;
        });
      });
      draft.isChanged = true;
    });
  };

  const onSwitchChange = (e) => {
    const value = e.target.checked === true ? 1 : 0;
    setIngredients((draft) => {
      if (draft.data.alt_units.length === 0) {
        draft.data.alt_units = [{ base_unit_id: 0 }];
      }

      draft.data.alt_units[0].base_unit_id = globalData?.defaultUnits.find(
        (i) => i.label === "kg",
      ).value;

      draft.data.alt_units[0].base_unit_qty = ingredients.data.total_weight;
      draft.data.is_alternate_UOM = value;
      if (value === 0) {
        draft.data.selling_unit_id = "";
      }
    });
  };

  /////////////////////////////////////calculation///////////////////////////////////////
  const calculateTotalQtyForGroup = (group) => {
    if (!group?.ingredients?.length) return "0.0000";

    let totalQty = 0;

    group.ingredients.forEach((ingredient) => {
      const { units } = ingredient;
      const { qty } = calculateWeightInGrams(ingredient, units); // assuming this returns qty in grams
      totalQty += qty;
    });

    return (totalQty / 1000).toFixed(4); // convert to kg and format to 4 decimals
  };
  const calculateWeightInGrams = (ingredient, dataArray) => {
    const id = Number(ingredient.base_unit_id);
    const baseQty = Number(ingredient?.base_unit_qty);
    const isIgnoredUnit = ignoredList?.some((item) => item.alt_unit_id === id);

    if (isIgnoredUnit) return { qty: 0 };
    const baseUnitId =
      globalData?.defaultUnits.find((i) => i.label === "gm")?.value || 1;
    const hasBaseUnit = dataArray?.some(
      (item) => item.alt_unit_id === baseUnitId,
    );

    if (id && dataArray?.length > 0) {
      let currentBaseUnitId = id;
      let qty = baseQty ? baseQty : 0;

      if (hasBaseUnit) {
        while (baseUnitId !== currentBaseUnitId) {
          const baseUnit = dataArray.find(
            (item) => item.alt_unit_id === currentBaseUnitId,
          );
          if (!baseUnit) break;
          currentBaseUnitId = baseUnit?.base_unit_id;
          qty = qty * (baseUnit?.base_unit_qty / baseUnit?.alt_unit_qty);
        }
      } else {
        qty = 0;
      }

      return { qty };
    } else {
      return { qty: 0 };
    }
  };

  const iterateAndCalculateWeight = () => {
    let finalTotal = 0;
    ingredients?.data?.groups.forEach((group) => {
      group?.ingredients?.forEach((ingredient) => {
        const { units } = ingredient;
        const { qty } = calculateWeightInGrams(ingredient, units);

        finalTotal += qty;
      });
    });
    return (finalTotal / 1000).toFixed(4);
  };

  let totalItemWeight = iterateAndCalculateWeight();

  useEffect(() => {
    const fullIngredients = ingredients.data.groups.flatMap(
      (group) => group.ingredients,
    );
    const hasMainIngredient = fullIngredients.some(
      (item) => item.is_main_ingredient === 1,
    );

    if (
      ingredients?.data?.is_alternate_UOM === 1 &&
      ingredients.data.alt_units.length > 0
    ) {
      setIngredients((draft) => {
        draft.data.alt_units[0].base_unit_qty = hasMainIngredient
          ? ingredients.data.total_weight
          : totalItemWeight;
      });
    }

    const totalIngredientQty = ingredients?.data?.groups.reduce(
      (sum, group) => {
        const groupTotal = calculateTotalQtyForGroup(group);
        const qty =
          group.has_boiling_weight === 1
            ? parseFloat(group.total_qty || 0)
            : parseFloat(groupTotal || 0);
        return sum + qty;
      },
      0,
    );

    setIngredients((draft) => {
      draft.data.total_ingredient_weight = Number(totalItemWeight);
      draft.data.total_weight = Number(totalIngredientQty);
    });
  }, [ingredients]);

  useEffect(() => {
    if (
      ingredientsDetails.isSuccess &&
      listQuery.isSuccess &&
      ingredientsDetails?.data?.condition === 1
    ) {
      const groupIds = ingredientsDetails?.data?.groups?.map((group, index) => {
        if (group?.ingredients) {
          return {
            ...group,
            total_qty: group.total_qty ?? 0,
            total_ingredient_qty: group.total_ingredient_qty ?? 0,
            ingredients: group?.ingredients.map((ingredient) => ({
              ...ingredient,
              groupIndex: index,
              units: [...ingredient.units, ...ignoredList],
            })),
          };
        }
        return group;
      });

      const { alternative_uom, groups, total_weight, ...ingredientsData } =
        ingredientsDetails.data;

      let parsedTotalWeight = parseFloat(total_weight);

      setIngredients((draft) => {
        draft.data = {
          ...ingredientsData,
          alt_units: alternative_uom,
          groups: groupIds,
          total_weight: parsedTotalWeight,
        };
      });
    }
  }, [ingredientsDetails.data, listQuery.isSuccess]);

  const checkFinishedProduct = () => {
    let isFinishedProduct = false;
    if (detailsId && ingredientsDetails?.data?.type === "finishedproduct") {
      isFinishedProduct = true;
    } else if (typeParams === "finishedproduct") {
      isFinishedProduct = true;
    } else {
      isFinishedProduct = false;
    }
    return isFinishedProduct;
  };

  const ingredientsOnSubmit = () => {
    if (
      ingredientsValidator.current.allValid() &&
      unitValidator.current.allValid()
    ) {
      console.log(
        detailsId && ingredients.isChanged,
        detailsId,
        ingredients.isChanged,
      );
      const { type, plu } = basicdetails.data;

      if (
        type !== "recipe" &&
        plu &&
        detailsId &&
        ingredients.isChanged &&
        globalData?.pos_sync_settings?.[0]?.value
      ) {
        handleSyncModal(true);
      } else {
        handleIngredientsOnSubmit();
      }
    } else {
      ingredientsValidator.current.showMessages();
      unitValidator.current.showMessages();
      forceUpdate(1);
    }
  };

  const handleSyncModal = (state) => {
    setIngredients((draft) => {
      draft.isOpenSyncModal = state;
      draft.data.sync_type = "scheduled";
    });
  };

  const handleIngredientsOnSubmit = () => {
    const {
      alt_units,
      groups,
      is_alternate_UOM,
      total_weight,
      selling_unit_id,
      total_ingredient_weight,
      scheduled_date,
      sync_type,
    } = ingredients.data;
    const fullIngredients = groups.flatMap((group) => group.ingredients);
    const hasMainIngredient = fullIngredients.some(
      (item) => item.is_main_ingredient === 1,
    );

    const isFinishedProduct = checkFinishedProduct();
    let formData = new FormData();
    formData.append("recipe_id", createId);
    formData.append("is_alternate_UOM", is_alternate_UOM);
    formData.append("total_weight", total_weight);
    formData.append("total_ingredient_weight", total_ingredient_weight);
    isFinishedProduct && formData.append("selling_unit_id", selling_unit_id);

    if (detailsId && sync_type) {
      formData.append(
        `scheduled_date`,
        scheduled_date ? moment(scheduled_date).format("YYYY-MM-DD") : "",
      );
      formData.append(`sync_type`, sync_type);
    }

    // Append alt_units
    if (is_alternate_UOM === 1) {
      alt_units?.map((item, index) => {
        formData.append(
          `alt_units[${index}][base_unit_qty]`,
          item.base_unit_qty,
        );
        formData.append(`alt_units[${index}][base_unit_id]`, item.base_unit_id);
        formData.append(`alt_units[${index}][alt_unit_qty]`, item.alt_unit_qty);
        formData.append(`alt_units[${index}][alt_unit_id]`, item.alt_unit_id);
      });
    }

    // Append groups
    groups.map((group, groupIndex) => {
      const totalQtyForGroup = calculateTotalQtyForGroup(group);

      const position = groupIndex;
      let groupName = `Group ${groupIndex + 1}`;

      formData.append(
        `groups[${groupIndex}][total_qty]`,
        group?.has_boiling_weight === 0 ? totalQtyForGroup : group?.total_qty,
      );
      formData.append(`groups[${groupIndex}][total_qty_unit]`, "kg");
      formData.append(`groups[${groupIndex}][name]`, groupName);
      formData.append(`groups[${groupIndex}][position]`, position);
      formData.append(
        `groups[${groupIndex}][total_ingredient_qty]`,
        totalQtyForGroup,
      );
      formData.append(
        `groups[${groupIndex}][has_boiling_weight]`,
        group?.has_boiling_weight ? 1 : 0,
      );
      group.ingredients.map((ingredient, ingredientIndex) => {
        formData.append(
          `groups[${groupIndex}][ingredients][${ingredientIndex}][ingredient_id]`,
          ingredient.ingredient_id,
        );
        formData.append(
          `groups[${groupIndex}][ingredients][${ingredientIndex}][base_unit_id]`,
          ingredient.base_unit_id,
        );
        formData.append(
          `groups[${groupIndex}][ingredients][${ingredientIndex}][base_unit_qty]`,
          ingredient.base_unit_qty,
        );
        formData.append(
          `groups[${groupIndex}][ingredients][${ingredientIndex}][is_main_ingredient]`,
          hasMainIngredient
            ? ingredient.is_main_ingredient
            : groupIndex === 0 && ingredientIndex === 0
              ? 1
              : 0,
        );
        formData.append(
          `groups[${groupIndex}][ingredients][${ingredientIndex}][type]`,
          ingredient.type,
        );
      });
    });

    detailsId
      ? groups.length
        ? updateIngredients.mutate({
            detailsId,
            formData,
            handleChange,
            handleSyncModal,
          })
        : errorMessage("The groups field is required.")
      : groups.length
        ? createIngredients.mutate({
            formData,
            handleChange,
            createId,
            handleSyncModal,
          })
        : errorMessage("The groups field is required.");
  };

  const handleScheduledChange = (event) => {
    const { value, name } = event.target;
    setIngredients((draft) => {
      draft.data[name] = value;
    });
  };

  //////chart settings///////////////

  const onChange = (e) => {
    const { name, value } = e.target;
    setChartSettings((draft) => {
      draft.data[name] = value;
    });
  };

  const onBreadModularChange = (e) => {
    const value = e.target.checked === true ? 1 : 0;
    setChartSettings((draft) => {
      draft.data.bread_moulder_enabled = value;
    });
  };

  const onProvingTimeChange = (e) => {
    const value = e.target.checked === true ? 1 : 0;
    setChartSettings((draft) => {
      draft.data.proving_time_enabled = value;
    });
  };

  const onOvenTimeChange = (e) => {
    const value = e.target.checked === true ? 1 : 0;
    setChartSettings((draft) => {
      draft.data.oven_time_temp_enabled = value;
    });
  };

  const onProductionChange = (e) => {
    const value = e.target.checked === true ? 1 : 0;
    setChartSettings((draft) => {
      draft.data.production_wastage_enabled = value;
    });
  };

  const onRollMoulderChange = (e) => {
    const value = e.target.checked === true ? 1 : 0;
    setChartSettings((draft) => {
      draft.data.roll_moulder_enabled = value;
    });
  };

  const onPastrySheeterChange = (e) => {
    const value = e.target.checked === true ? 1 : 0;
    setChartSettings((draft) => {
      draft.data.pastry_sheeter_enabled = value;
    });
  };

  const onInductionCookerChange = (e) => {
    const value = e.target.checked === true ? 1 : 0;
    setChartSettings((draft) => {
      draft.data.induction_cooker_status = value;
    });
  };

  const chartRadioButtonChange = (value) => {
    setChartSettings((draft) => {
      draft.data.primary = value;
    });
  };

  const onButtonChange = (value) => {
    setChartSettings((draft) => {
      draft.data.mandatory = value;
    });
  };

  const onBeforeBakingChange = (e) => {
    const value = e.target.checked === true ? 1 : 0;
    setChartSettings((draft) => {
      draft.data.before_baking = value;
    });
  };

  const onBeforeDecoratingChange = (e) => {
    const value = e.target.checked === true ? 1 : 0;
    setChartSettings((draft) => {
      draft.data.after_baking = value;
    });
  };

  useEffect(() => {
    if (
      chartSettingsDetails?.status === "success" &&
      chartSettingsDetails?.data?.condition === 1
    ) {
      setChartSettings((draft) => {
        draft.data = chartSettingsDetails.data;
      });
    }
  }, [chartSettingsDetails.status]);

  const chartSettingsOnSubmit = () => {
    const payload = {
      ...chartSettings.data,
      recipe_id: createId,
    };
    detailsId
      ? updateChartSettings.mutate({ detailsId, payload, handleChange })
      : createChartSettings.mutate({
          payload,
          handleChange,
          createId,
        });
  };

  ///////////////////how to prepare hooks//////////////////

  const addStepChangeHandler = () => {
    const newRows = {
      step: "",
      formattedStep: "",
      image_url: "",
    };
    setState((draft) => {
      const currentRow = draft.data.steps;
      currentRow.push(newRows);
    });
  };

  const onOrderChange = (data) => {
    setState((draft) => {
      draft.data.steps = data;
    });
  };

  const handleQuillChange = (name, value) => {
    setState((draft) => {
      draft.data[name] = value;
    });
  };

  const removeImage = (index) => {
    setState((draft) => {
      draft.data.steps[index].image_url = "";
      draft.data.steps[index].imageFile = "";
    });
  };

  const handleDropzone = (e, index) => {
    const imageFile = e[0];
    setState((draft) => {
      draft.data.steps[index].imageFile = imageFile;
      draft.data.steps[index].loading = true;
      draft.index = index;
    });

    let imageFormdata = new FormData();
    imageFormdata.append("type", "image");
    imageFormdata.append("media", imageFile);
    createImageVideoUrl.mutate(imageFormdata);

    indexRef.current = index;
  };
  const indexRef = useRef();

  useEffect(() => {
    if (createImageVideoUrl.data) {
      const imageIndex = indexRef.current;
      setState((draft) => {
        draft.data.steps[imageIndex].image_url = createImageVideoUrl?.data?.url;
        draft.data.steps[imageIndex].loading = false;
      });
    }
  }, [createImageVideoUrl.data]);

  const handleDropzoneVideo = (event) => {
    const videoFile = event.target.files[0];
    let videoFormdata = new FormData();
    videoFormdata.append("type", "recipe_video");
    videoFormdata.append("media", videoFile);
    createVideoUrl.mutate(videoFormdata);
  };
  const handleStepChange = (content, index) => {
    setState((draft) => {
      const step = draft.data.steps[index];
      if (step && step.step !== content) {
        step.step = content;
        step.formattedStep = content.replace(/<\/?[^>]+(>|$)/g, ""); // Non-render logic
      }
    });
  };
  useEffect(() => {
    if (createVideoUrl?.data) {
      const videoUrl = createVideoUrl.data;
      const hasVideoUrl = state.data.videos.some((obj) =>
        Object.values(obj).includes(videoUrl.url),
      );
      if (!hasVideoUrl) {
        setState((draft) => {
          draft.data.videos.push({
            video_url: videoUrl.url,
            video_name: videoUrl.doc_name,
          });
        });
      } else {
        console.log(`${videoUrl.url} already exists in the array of objects.`);
      }
    }
  }, [createVideoUrl?.data]);

  const stepsHandleDelete = (index) => {
    setState((draft) => {
      draft.data.steps = [...draft.data.steps.filter((data, i) => i !== index)];
    });
  };

  const handleDeleteVideos = (index) => {
    setState((draft) => {
      draft.data.videos = [
        ...draft.data.videos.filter((data, i) => i !== index),
      ];
    });
  };

  useEffect(() => {
    if (
      preparationStepsDetails?.status === "success" &&
      preparationStepsDetails?.data?.condition === 1
    ) {
      setState((draft) => {
        const { method, steps, videos, condition } =
          preparationStepsDetails.data;
        draft.data.condition = condition;
        draft.data.method = method;
        draft.data.videos = videos || [];
        draft.data.steps = steps.map((step) => ({
          step: step.step || "",
          formattedStep: step?.step?.replace(/<\/?[^>]+(>|$)/g, "") || "",
          image_url: step.image_url || "",
          imageFile: "",
          step_number: step.step_number,
          loading: false,
          display_order: step.display_order,
        }));
      });
    }
  }, [preparationStepsDetails.status]);

  const setVideoUrl = (e) => {
    setState((draft) => {
      draft.videoUrl = e?.target?.value;
    });
  };

  // console.log("videoUrl", state.videoUrl);

  const onClearVideoUrl = () => {
    setState((draft) => {
      draft.videoUrl = "";
    });
  };

  const handleKeyDown = (e) => {
    console.log("key", e.key);
    if (e.key === "Enter") {
      e.preventDefault();
      videoUrlOnChange();
    }
  };

  const videoUrlOnChange = () => {
    const { videoUrl } = state;
    setState((draft) => {
      draft.data.videos.push({ video_url: videoUrl });
      draft.videoUrl = "";
    });
  };

  const onSubmit = async () => {
    if (howToPrepareValidator.current.allValid()) {
      const { steps, videos } = state.data;
      let formData = new FormData();
      formData.append("recipe_id", createId);
      if (detailsId) {
        formData.append("method", state.data.method ?? "");

        videos.forEach((item, index) => {
          formData.append(`videos[${index}][video_url]`, item.video_url);
        });

        steps.forEach((img, index) => {
          formData.append(`steps[${index}][image_url]`, img.image_url ?? "");
        });

        steps.forEach((item, index) => {
          formData.append(`steps[${index}][step]`, item.step);
        });
      } else {
        state.data.method && formData.append("method", state.data.method);

        videos.length &&
          videos.forEach((item, index) => {
            formData.append(`videos[${index}][video_url]`, item.video_url);
          });
        const hasSteps = steps.some((item) => item.step);
        if (hasSteps) {
          steps.forEach((img, index) => {
            formData.append(`steps[${index}][image_url]`, img.image_url);
          });

          steps.forEach((item, index) => {
            formData.append(`steps[${index}][step]`, item.step);
          });
        }
      }

      detailsId
        ? updatePreparationSteps.mutate({ detailsId, formData, handleChange })
        : createRecipePreapration.mutate({
            formData,
            handleChange,
          });
    } else {
      howToPrepareValidator.current.showMessages();
      forceUpdate(1);
    }
  };

  const saveAndSubmit = (index) => {
    switch (index) {
      case "basic":
        basicDetailsOnSubmit();
        break;
      case "ingredients":
        ingredientsOnSubmit();
        break;
      case "settings":
        chartSettingsOnSubmit();
        break;
      case "prepare":
        onSubmit();
        break;
      default:
        console.log("no option");
    }
  };
  const updateTableData = (row, columnId, value, type) => {
    const rowIndex = row?.index;
    const groupIndex = row?.original?.groupIndex;
    if (type === "Ingredients") {
      setIngredients((draft) => {
        draft.data.groups[groupIndex].ingredients[rowIndex][columnId] = value;
        draft.isChanged = true;
      });
    } else if (type === "AltUOM") {
      setIngredients((draft) => {
        draft.data.alt_units[rowIndex][columnId] = value;
        draft.isChanged = true;
      });
    } else {
      setState((draft) => {
        if (draft.data.steps[rowIndex]) {
          draft.data.steps[rowIndex][columnId] = value;
        }
      });
    }
  };
  const handleDragEnd = (result) => {
    const { source, destination } = result;

    // Return if item dropped outside of list
    if (!destination) return;

    // Reorder steps
    const reorderedSteps = Array.from(state.data.steps);
    const [movedStep] = reorderedSteps.splice(source.index, 1);
    reorderedSteps.splice(destination.index, 0, movedStep);
    setState((draft) => {
      draft.data.steps = reorderedSteps;
    });
  };
  const handleHasBoilingWeight = (e) => {
    const value = e.target.value === true || e.target.checked ? 1 : 0;
    const index = e.index;

    setIngredients((draft) => {
      if (draft.data?.groups?.[index]) {
        if (value === true) {
          draft.data.groups[index].has_boiling_weight = value;
        } else {
          draft.data.groups[index].has_boiling_weight = value;
          draft.data.groups[index].total_qty = 0;
        }
      }
      draft.isChanged = true;
    });
  };
  const onGroupChange = (e, index) => {
    const value = e.target.value;
    setIngredients((draft) => {
      if (draft.data?.groups?.[index]) {
        draft.data.groups[index].total_qty = value;
      }
      draft.isChanged = true;
    });
  };
  const handleDialogClose = () => {
    setIngredients((draft) => {
      draft.isErrorMessage = false;
    });
  };

  return {
    basicdetails,
    validator,
    categoryIds,
    typeData,
    value,
    basicDetailsHandleDropzone,
    CategoryChangeHandler,
    SubcategoryChangeHandler,
    TypeHandler,
    onHandleChange,
    handleRemoveImage,
    basicDetailsOnChange,
    saveAndSubmit,
    handleChange,
    basicDetailsData,
    createImageUrl,
    handleTabCLick,

    ingredients,
    ingredientsList,
    alternativeunitList,
    updateTableData,
    IngredientsChangehandler,
    unitsChangehandler,
    addIngredientsHandle,
    handleRemoveRows,
    addNewGroup,
    onRadioButtonChange,
    altUnitChangeHandler,
    addUnitsHandle,
    onSwitchChange,
    handleDelete,
    handleSuccessModal,
    handleSyncModal,
    handleScheduledChange,
    handleIngredientsOnSubmit,

    chartSettings,
    onChange,
    onBreadModularChange,
    onProvingTimeChange,
    onRollMoulderChange,
    onPastrySheeterChange,
    onOvenTimeChange,
    onProductionChange,
    chartRadioButtonChange,
    onButtonChange,
    onBeforeBakingChange,
    onBeforeDecoratingChange,

    state,
    handleQuillChange,
    handleDropzone,
    addStepChangeHandler,
    stepsHandleDelete,
    handleDropzoneVideo,
    handleDeleteVideos,
    createImageVideoUrl,
    listQuery,
    handleKeyDown,
    setVideoUrl,
    howToPrepareValidator,
    onClearVideoUrl,
    createVideoUrl,
    onIngredientsOrderChange,
    onOrderChange,
    search,
    ingredientsValidator,
    ignoredList,
    combinedArray,
    removeImage,
    pluOptions,
    optionsTaxGroup,
    sellingUnitChange,
    checkFinishedProduct,
    unitValidator,
    ingredientsDetails,
    quillRef,
    handleStepChange,
    handleDragEnd,
    globalData,
    onInductionCookerChange,
    handleHasBoilingWeight,
    onGroupChange,
    calculateTotalQtyForGroup,
    handleDialogClose,
    moveIngredient,
  };
};
